import { AmazonDataState } from "../types/project"
import NotAvailableTag from "./NotAvailableTag"

interface NotAvailableTagKeywordProps {
  state: AmazonDataState
}

const NotAvailableTagKeyword: React.FC<NotAvailableTagKeywordProps> = ({ state }) => {
  return state && state !== AmazonDataState.AVAILABLE ? (
    <NotAvailableTag
      amazonDataState={state}
      tooltipText={
        state === AmazonDataState.NOT_IN_AMAZON
          ? "No results found for this keyword on Amazon"
          : "Data is being fetched from Amazon. This can take up to 2 hours."
      }
    />
  ) : null
}

export default NotAvailableTagKeyword
